import * as yup from 'yup';

export const FIELD_TITLE = 'title';
export const FIELD_TITLE_RU = 'title.ru';
export const FIELD_TITLE_UZ = 'title.uz';
export const FIELD_TITLE_OZ = 'title.oz';
export const FIELD_CODE = 'code';

export const RegionsEditValidationForm = yup.object().shape({
  [FIELD_TITLE_RU]: yup.string().trim(),
  [FIELD_TITLE_UZ]: yup.string().trim(),
  [FIELD_TITLE_OZ]: yup.string().trim(),
  [FIELD_CODE]: yup.string().required('error.required').trim(),
});
